<template>
  <div id="app" class="ls-application ls-application--is-ltr" :data-uzair-theme="isDarkMode ? 'dark' : 'light'">
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import { parseLocalSItem } from '@/core/providers/local_storage/localStorage.provider';
import { printLog } from '@/core/libs';

export default {
  name: 'App',
  computed: {
    isRemember() {
      return this.$store.state.Auth.is_remember;
    },
    ...mapGetters('Users', ['me']),
    ...mapState('Uzair', ['isDarkMode']),
  },

  created() {
    this.handleUzairThemeMode();
  },

  methods: {
    ...mapActions('Uzair', ['toggleThemeMode']),

    handleUzairThemeMode() {
      const isDarkMode = parseLocalSItem('isDarkMode', 'boolean');
      if (![undefined, null].includes(isDarkMode)) {
        printLog('Theme set to:', isDarkMode ? 'dark' : 'light');
        this.toggleThemeMode(isDarkMode);
      }
    },
  },
};
</script>

<style lang="scss">
@import "core/styles/main.scss";
</style>
